import React, { useState } from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { createSx } from '../../../../../utils';
import { Attachment } from '../../..';
import { ATTACHMENTS_SIZE } from '../const';
import EllipsedTypography from '../../../../Tooltip/EllipsedTypography';

const sx = createSx({
  root: {
    cursor: 'pointer',
    boxSizing: 'border-box',
    borderRadius: 0.5,
    border: '1px solid',
    borderColor: 'neutral.outlineVariant',
    color: 'primary.onContainer',
    backgroundColor: 'primary.container',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    objectFit: 'cover',
  },
  attachmentName: {
    px: 0.5,
    maxWidth: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
  }
});

interface Props<T extends Attachment> {
  attachment: T;
  size?: number | string;
  onClick?: () => void;
}

const AttachmentThumbnail = <T extends Attachment, >({
  attachment,
  size = ATTACHMENTS_SIZE,
  onClick,
}: Props<T>) => {
  const [isError, setIsError] = useState(false);

  if (isError) {
    return (
      <Stack
        sx={sx.root}
        width={size}
        height={size}
        spacing={0.5}
        onClick={onClick}
        data-test-id='attachments-item'>
        <InsertDriveFileOutlinedIcon />
        <EllipsedTypography
          variant='body2'
          testID='attachment-name'
          sx={sx.attachmentName}
          title={attachment.name}
        >
          {attachment.name}
        </EllipsedTypography>
      </Stack>
    );
  }

  return (
    <Box
      onClick={onClick}
      component='img'
      sx={sx.root}
      width={size}
      height={size}
      src={attachment.url}
      alt={attachment.name}
      data-test-id='attachments-item'
      onError={() => {
        setIsError(true);
      }}
    />
  );
};

export default AttachmentThumbnail;